export function parseResponse(response: any): any[] {
    if(!response.entity){
        return [];
    }
    if(response.entity.hasOwnProperty('aaData')) {
        return response.entity.aaData || [];
    }
    return response.entity;
}